/**
 * Helpers for WeChat OCR + banking applyment fields (aligned with mendiantong-merchant).
 */

export function normalizeCnDate(str) {
  if (str == null) return null;
  const raw = String(str).trim();
  if (!raw || raw === "长期") return null;
  const m = raw.match(/(\d{4})\D*(\d{1,2})\D*(\d{1,2})/);
  if (!m) return null;
  const y = m[1];
  const mo = String(m[2]).padStart(2, "0");
  const d = String(m[3]).padStart(2, "0");
  return `${y}-${mo}-${d}`;
}

export function parseIdValidRange(validDate) {
  const raw = String(validDate || "").trim();
  if (!raw) return { start: null, end: null, longTerm: false };
  if (raw.includes("长期") || /长期/.test(raw)) {
    const startOnly = raw.split(/[-~至]/)[0];
    return {
      start: normalizeCnDate(startOnly),
      end: null,
      longTerm: true,
    };
  }
  const parts = raw.split(/[-~至]/).map((s) => s.trim()).filter(Boolean);
  return {
    start: normalizeCnDate(parts[0]),
    end: normalizeCnDate(parts[1]),
    longTerm: false,
  };
}

export function mapBizLicenseOcr(data) {
  if (!data || typeof data !== "object") return {};
  const patch = {};
  if (data.reg_num) patch.licence_number = String(data.reg_num);
  if (data.enterprise_name) patch.licence_name = String(data.enterprise_name);
  if (data.legal_representative) {
    patch.licence_legal_representative = String(data.legal_representative);
  }
  if (data.enterprise_name) {
    patch.merchant_abbr = String(data.enterprise_name).slice(0, 20);
  }
  return patch;
}

export function mapIdCardOcr(data) {
  if (!data || typeof data !== "object") return {};
  const patch = {};
  // Front (portrait)
  if (data.name) patch.id_full_name = String(data.name);
  if (data.id) patch.id_number = String(data.id);
  if (data.addr) patch.id_address = String(data.addr);
  // Back (emblem)
  if (data.valid_date) {
    const range = parseIdValidRange(data.valid_date);
    if (range.start) patch.id_start_date = range.start;
    if (range.end) patch.id_end_date = range.end;
    if (range.longTerm) patch.is_id_long_term = true;
  }
  return patch;
}

export function mapBankCardOcr(data) {
  if (!data || typeof data !== "object") return {};
  const patch = {};
  const bankAccount =
    data.bank_account ?? data.card_number ?? data.number ?? data.bank_card_no;
  const accountName = data.bank_account_name ?? data.account_name ?? data.name;
  if (bankAccount) patch.bank_account = String(bankAccount).replace(/\s+/g, "");
  if (accountName) patch.bank_account_name = String(accountName);
  return patch;
}

export function unwrapBankingList(payload) {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.data)) return payload.data;
  if (payload.data && Array.isArray(payload.data.data)) return payload.data.data;
  return [];
}

export function bankListTitle(b) {
  const ab = String(b?.account_bank ?? "").trim();
  if (ab) return ab;
  return String(b?.bank_alias ?? "").trim();
}

export function bankMatchesSearchKeyword(b, keyword) {
  const q = String(keyword ?? "").trim().toLowerCase();
  if (!q) return true;
  return [b?.account_bank, b?.bank_alias, b?.bank_alias_code]
    .map((x) => String(x ?? "").toLowerCase())
    .some((p) => p.includes(q));
}
